import { InferenceVolumeSharedEndpointInstantDocument } from '@/sections/Workspace/Metrics/Tabs/__generated__/queries.generated';
import { useMetricQuery } from '@/sections/Workspace/Metrics/hooks';

function useOrgSharedEndpointsInferenceVolume(id: string, isVisible = true) {
  const { data, loading } = useMetricQuery({
    document: InferenceVolumeSharedEndpointInstantDocument,
    isVisible,
    isSharedEndpoint: true,
    isTrainingJob: false,
    providerId: id,
    timeDivisorSeconds: 3600, // Use 1 hour (3600 seconds) as time divisor to show requests per hour
  });

  return {
    data,
    loading,
  };
}

export { useOrgSharedEndpointsInferenceVolume };
